import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { intlShape, injectIntl } from 'react-intl';
import {
  Modal,
  ModalButtons,
  ModalContent,
  Button,
  ProgressBar,
  Label,
  TextField
} from 'mw-style-react';
import { GET_QR_CODE, SEND_QR_CODE } from 'constants';
import AppUtils from '../../../../utils/utils';
import mes from './intl';
import auth from '../../../../images/2FAuth.png';
import authLike from '../../../../images/2FAuthLike.png';
import sModal from '../../Modal.scss'; // eslint-disable-line no-unused-vars
import sLocal from './TwoFactorAuth.scss'; // eslint-disable-line no-unused-vars

class TwoFactorAuth extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      qrCode: '',
      qrCodeValue: '',
      qrCodeError: false,
      helperText: ''
    };
  }

  // Ф-ция локализации
  i(mesId, values) {
    return AppUtils.getMes(this.context)(mesId, values);
  }

  handleInputChange(field, name) {
    this.setState({
      [name]: field.value,
      qrCodeError: false,
      helperText: ''
    });
  }

  setStep(step) {
    if (step === 2) {
      this.props.dispatch({
        type: GET_QR_CODE.REQUEST,
        callback: code => {
          this.setState({
            qrCode: code.qr_code_b64
          });
        }
      });
    }

    if (step === 5) {
      this.props.dispatch({
        type: SEND_QR_CODE.REQUEST,
        payload: this.state.qrCodeValue,
        callback: data => {
          if (data.result === 'error') {
            this.setStep(4);
            this.setState({
              qrCodeError: true,
              helperText: data.message || data.description || ''
            });
          } else {
            this.setState({
              step
            });
          }
        }
      });
    } else {
      this.setState({
        step
      });
    }
  }

  renderContent(step) {
    switch (step) {
      case 1:
        return (
          <div styleName="sModal.modal__content sLocal.content">
            <div styleName="sLocal.center">
              <img src={auth} alt="auth" width="100px" height="100px" />
            </div>
            <div styleName="sLocal.center">
              <Label
                value={"We use Google's two-factor authentication to secure your account"}
                fontWeight="semibold"
              />
            </div>
            <Label
              value={
                "With the Google Authenticator app, you'll get a randomly generated code to login, even without an internet or mobile network connection. And if an attacker finds out the password for your account, they won't be able to access it without entering the code."
              }
            />
          </div>
        );

      case 2:
        return (
          <div styleName="sModal.modal__content sLocal.content">
            <div styleName="sLocal.center">
              {this.state.qrCode ? (
                <img
                  src={`data:image/jpeg;base64,${this.state.qrCode}`}
                  alt="qrCode"
                  width="100px"
                  height="100px"
                />
              ) : (
                <div style={{ height: '144px' }} />
              )}
            </div>
            <div styleName="sLocal.center">
              <Label value="Please istall Google Authenticator" fontWeight="semibold" />
            </div>
            <Label value="Scan with the camera or a dedicated application the QR code below with a link to the Google Authenticator application and install it on your smartphone." />
          </div>
        );

      case 3:
        return (
          <div styleName="sModal.modal__content sLocal.content">
            <div styleName="sLocal.center">
              {this.state.qrCode ? (
                <img
                  src={`data:image/jpeg;base64,${this.state.qrCode}`}
                  alt="qrCode"
                  width="100px"
                  height="100px"
                />
              ) : (
                <div style={{ height: '144px' }} />
              )}
            </div>
            <div styleName="sLocal.center">
              <Label value="Setup Google Authenticator" fontWeight="semibold" />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Label
                value={
                  '1. Open the Google Authenticator application on your smartphone and click "Get started".'
                }
              />
              <Label value={'2. Select the "Barcode" option and scan the QR code.'} />
            </div>
          </div>
        );

      case 4:
        return (
          <div styleName="sModal.modal__content sLocal.content">
            <div styleName="sLocal.center">
              <Label value="Enter verification code" fontWeight="semibold" />
            </div>
            <div styleName="sLocal.center">
              <Label value="Enter the six-digit code displayed in Google Authenticator" />
            </div>
            <div styleName="sLocal.center">
              <TextField
                value={this.state.qrCodeValue}
                onChange={e => this.handleInputChange(e, 'qrCodeValue')}
                bordered={true}
                error={this.state.qrCodeError}
                helperText={this.state.helperText}
              />
            </div>
          </div>
        );

      case 5:
        return (
          <div styleName="sModal.modal__content sLocal.content">
            <div styleName="sLocal.center">
              <img src={authLike} alt="auth" width="100px" height="100px" />
            </div>
            <div styleName="sLocal.center">
              <Label value="Congratulations" fontWeight="semibold" />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Label value="Configuring two-factor authentication is complete. Your account is now secure. On the next logging into an account, we will ask you for a six-digit code from the Google Authenticator application." />
              <div>
                <Label value="If you have any difficulties or questions, please contact " />
                <a href="mailto: support@corezoid.com">support@corezoid.com</a>.
              </div>
            </div>
          </div>
        );
      default:
        return <div />;
    }
  }

  render() {
    const { visibility, onClose, isSubmit } = this.props;

    const { step } = this.state;

    const steps = [1, 2, 3, 4, 5];

    return (
      <Modal
        styleName="sLocal.titleHead"
        visibility={visibility}
        onClose={onClose}
        label="Enable Two-factor authentication"
      >
        <ModalContent styleName="sModal.modal__content sLocal.content">
          <div styleName="sLocal.steps">
            {steps.map((s, index) => (
              <div
                key={index}
                styleName={step >= s ? 'sLocal.step sLocal.step__active' : 'sLocal.step'}
              >
                <Label value={s} fontSize="large" fontWeight="semibold" />
              </div>
            ))}
          </div>
          {this.renderContent(step)}
        </ModalContent>
        <ModalButtons styleName="sModal.modal__buttons">
          {step !== 5 && step > 1 ? (
            <Button
              label="Back"
              size="medium"
              type="text"
              onClick={() => this.setStep(step - 1)}
              visibility={isSubmit ? 'disabled' : 'visible'}
            />
          ) : (
            <Button
              label={this.i(mes.cancel)}
              size="medium"
              type="text"
              onClick={onClose}
              visibility={step === 5 ? 'hidden' : 'visible'}
            />
          )}
          {step === 5 ? (
            <Button
              label="Finish"
              size="medium"
              onClick={onClose}
              visibility={isSubmit ? 'disabled' : 'visible'}
            />
          ) : (
            <Button
              label="Next"
              size="medium"
              onClick={() => this.setStep(step + 1)}
              visibility={isSubmit ? 'disabled' : 'visible'}
            />
          )}
          <ProgressBar
            styleName="sModal.modal__loader"
            type="circle"
            size="small"
            visibility={isSubmit ? 'visible' : 'hidden'}
          />
        </ModalButtons>
      </Modal>
    );
  }
}

TwoFactorAuth.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  isSubmit: PropTypes.bool,
  dispatch: PropTypes.func
};

TwoFactorAuth.contextTypes = {
  intl: intlShape
};

export default injectIntl(TwoFactorAuth);
